enum MediaRenderError {
  MediaVersesRangeLimitExceeded = 'MediaVersesRangeLimitExceeded',
  MediaFilesPerUserLimitExceeded = 'MediaFilesPerUserLimitExceeded',
}

export default MediaRenderError;
